import { Aggregator } from './aggregator';

/**
 * This aggregator is used to calculate the number of times a value has changed.
 * Only the first value is counted as a change, the rest duplicates are ignored.
 * Only string values are supported.
 */
export class ChangeCounter<T extends string> extends Aggregator<T> {
  private lastValue?: T;

  private changes?: number;

  constructor() {
    super();
  }

  getAggregated(): number | undefined {
    return this.changes;
  }

  reset(): void {
    this.lastValue = undefined;
    this.changes = undefined;
  }

  protected _add(value: T): void {
    if (this.lastValue && this.lastValue !== value) {
      this.changes = (this.changes ?? 0) + 1;
    }
    this.lastValue = value;
  }
}
